<template>
  <div class="setup-step-2">
    <Card flat>
      <template #title>
        <v-skeleton-loader
          v-if="pageLoading"
          type="heading"
          width="100%"
          height="28px"
          class="mt-1 mb-1"
        />
        <h5
          v-else
          class="mt-2 mb-2"
        >
          Step 2: Paste your ID, SAML URL and Certificate returned by your provider
        </h5>
      </template>

      <template #text>
        <div
          v-if="pageLoading"
          class="mt-6"
        >
          <v-skeleton-loader
            v-for="([type, width, height], i) in [
              ['text', '100', '30'],
              ['text', '100%', '50'],
              ['text', '100', '30'],
              ['text', '100%', '50'],
              ['text', '100', '30'],
              ['paragraph', '100%', '100'],
            ]"
            :key="i"
            v-bind="{ type, width, height }"
          />
        </div>
        <SsoSetupForm
          v-else
          class="mt-1"
          :form="{
            values, errors, errorMessages, labels,
          }"
          :disabled="isForced"
          @update:model-value="setFormValues($event)"
          @change="setIsValidated($event)"
        />

        <div class="d-flex justify-space-between">
          <v-skeleton-loader
            v-if="pageLoading"
            class="mt-2"
            type="text"
            width="200px"
          />
          <div
            v-else
            class="d-flex align-center"
          >
            <v-icon
              :color="!setupIsReady ? 'iconDefault' : 'success'"
              icon="$checkbox-marked-circle"
            />
            <h5 class="ml-2">
              {{ setupIsReady ? 'SSO Submitted!' : 'SSO Setup is not ready!' }}
            </h5>
          </div>

          <v-skeleton-loader
            v-if="pageLoading"
            height="40px"
            type="button"
          />
          <DpplAutoSizedButton
            v-else
            :disabled="isForced || !isFormValid"
            color="textDarkest"
            @click="submit"
          >
            {{ setupIsReady ? 'Save Changes' : 'Submit' }}
          </DpplAutoSizedButton>
        </div>

        <div class="mt-4 d-flex justify-space-between">
          <v-skeleton-loader
            v-if="pageLoading"
            class="mt-2"
            type="text"
            width="200px"
          />
          <div
            v-else
            class="d-flex align-center"
          >
            <v-icon
              :color="!lastSsoLoginDate ? 'iconDefault' : 'success'"
              icon="$checkbox-marked-circle"
            />
            <h5 class="ml-2">
              {{ lastSsoLoginDate ? 'SSO Tested!' : 'SSO is not tested' }}
            </h5>
          </div>

          <v-skeleton-loader
            v-if="pageLoading"
            height="40px"
            type="button"
          />
          <DpplAutoSizedButton
            v-else
            color="textDarkest"
            :disabled="!setupIsReady"
            @click="onConfigurationTestClick"
          >
            Test Configuration
          </DpplAutoSizedButton>
        </div>
      </template>
    </Card>
  </div>
</template>

<script>
import { mapState, mapActions } from 'pinia';
import { useAppLoading } from '@/stores/app/loading';
import { useSettingsSsoSetup } from '@/stores/settings/ssoSetup';
import { useSettingsSsoSetupForm } from '@/stores/settings/ssoSetupForm';
import DpplAutoSizedButton from '@/components/datapeople/DpplAutoSizedButton.vue';
import Card from './Card.vue';
import SsoSetupForm from './SsoSetupForm.vue';

export default {
  name: 'SetupStep2',

  components: { Card, DpplAutoSizedButton, SsoSetupForm },

  computed: {
    ...mapState(useAppLoading, ['pageLoading']),
    ...mapState(useSettingsSsoSetup, ['isForced', 'name', 'lastSsoLoginDate', 'setupIsReady']),
    ...mapState(useSettingsSsoSetupForm, ['values', 'errors', 'errorMessages', 'labels', 'isFormValid']),
  },

  methods: {
    ...mapActions(useSettingsSsoSetup, ['update']),
    ...mapActions(useSettingsSsoSetupForm, ['setFormValues', 'setIsValidated']),

    submit() {
      this.update(this.values);
    },

    onConfigurationTestClick() {
      window.sessionStorage.setItem('redirectRoute', JSON.stringify({ name: 'sso-setup' }));
      window.location.href = `/login/${this.name}`;
    },
  },
};
</script>

<style scoped lang="less">
.text-success {
  color: @basic-green;
}
.text-error {
  color: @basic-red;
}
</style>
